// import ModalForm from "./Form";
import PlacementBookingTableForm from "./PlacementBookingTableForm";
import PlacementBookingRescheduleTableForm from "./PlacementBookingRescheduleTableForm";
import PlacementBookingCancelTableForm from "./PlacementBookingCancelTableForm";
import PlacementBookingCancelResultTableForm from "./PlacementBookingCancelResultTableForm";
import PlacementBookingApproveTableForm  from "./PlacementBookingApproveTableForm";
// import PlacementBookingResultsTableForm from "./PlacementBookingResultsTableForm";
import {
	PLACEMENT,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";
import { isNull } from "lodash";

export const PlacementBookingTableSchema = {
	components: { PlacementBookingTableForm,PlacementBookingRescheduleTableForm,PlacementBookingCancelTableForm,PlacementBookingCancelResultTableForm,PlacementBookingApproveTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isRescheduleModalActive: false,
			isCancelModalActive: false,
			isAddEditModalActive: false,
			isResultsModalActive: false,
			isApproveModalActive: false,
			isCancelResultModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: "",
			Endpoint: 'PLACEMENT + "?clc_id_number=" + this.value.clc_id_number',
			tableId: "placement-booking-table",
			formId: "placement-booking-table-form",
			formIdResults: "placement-results-table-form",
			formIdReschedule: "placement-booking-reschedule-table-form",
			formIdCancel: "placement-booking-cancel-table-form",
			formIdCancelResult: "placement-booking-cancel-result-table-form",
			formIdApprove: "placement-booking-approve-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Assigned Date",
					type: "text",
					key: "assigned_at",
				},
				{
					title: "Appointment Type",
					type: "custom-html",
					key: "placement_type",
					modifier: (value) => {
						
						const typeMap = {
							1: "Class Trial",
							2: "Placement Test",
							3: "Direct",
						};

						const typeId = typeof value === "object" && value !== null ? value.id : value;
						return typeMap[typeId] || "-";
					},
				},
				{
					title: "Packages Name",
					type: "text",
					key: "package_name",
				},
				{
					title: "Product Name",
					type: "custom-html",
					key: "product",
					modifier: (value) => {
						return isNull(value) ? "" : value.name;
					},
				},
				{
					title: "Location Test",
					type: "text",
					key: "location_test",
				},
				{
					title: "Center",
					type: "custom-html",
					key: "center",
					modifier: (value) => {
						return isNull(value) ? "" : value.name;
					},
				},
				{
					title: "Assigned By",
					type: "custom-html",
					key: "assigned_by",
					modifier: (value) => {
						return isNull(value) ? "" : value.full_name;
					},
				},
				{
					title: "Booked Date",
					type: "custom-html",
					key: "booked_date",
					modifier: (value,rowData) => {
						if (rowData.placement_type.id != 3) {
							return value;
						}else{
							return '';
						}
					},
				},
				{
					title: "Booked Time",
					type: "custom-html",
					key: "booked_time",
					modifier: (value,rowData) => {
						
						if (rowData.placement_type.id != 3) {
							return value.slice(0, -3);
						}else{
							return '';
						}
						 
					}
				},
				// {
				// 	title: "Completed By",
				// 	type: "custom-html",
				// 	key: "completed_by",
				// 	modifier: (value) => {
				// 		return isNull(value) ? "" : value.full_name;
				// 	},
				// },
				// {
				// 	title: "Sub Status",
				// 	type: "custom-html",
				// 	key: "sub_status",
				// 	modifier: (value) => {
				// 		if (value && value.status) {
				// 			return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
				// 				value.status
				// 			)}</span>`;
				// 		}
				// 	},
				// },
				{
					title: "Placement Date",
					type: "custom-html",
					key: "placement_date",
					modifier: (value,rowData) => {
						
						if (rowData.placement_type.id != 3) {
							return value;
						}else{
							return '';
						}
						 
					}
				},
				// {
				// 	title: "Reference ID",
				// 	type: "text",
				// 	key: "reference_id",
				// },
				{
					title: "Status",
					type: "custom-html",
					key: "placement_status",
  					modifier: (value, rowData) => {
						const typeMap = {
							1: { text: "Reschedule", color: "orange" },
							2: { text: "Cancel", color: "red" },
							3: { text: "Confirm Parents", color: "green" },
							4: { text: "Attended", color: "blue" },
							5: { text: "Declained", color: "red" },
						};

						const typeId = typeof value === "object" && value !== null ? value.id : value;

						let text = "Onprocess";
						let color = "gray";

						if (rowData.placement_status == 5) {

							let textDeclained = '';
							if(rowData.type_declained == 1){
								textDeclained = '(Schedule Conflict)';
							}else if(rowData.type_declained == 2){
								textDeclained = '(Fee Issues)';
							}else if(rowData.type_declained == 3){
								textDeclained = '(Method Issues)';
							}else if(rowData.type_declained == 4){
								textDeclained = '(Other)';
							}

							text = `Declained <br> ${textDeclained ?? ""}`;
							color = "red";
						} else {
							const typeInfo = typeMap[typeId];
							if (typeInfo) {
								text = typeInfo.text;
								color = typeInfo.color;
							}
						}
						if(rowData.no_class == 1){
							text = 'Waiting List';
							color = 'orange';
						}

						return `<span style="color: ${color}; font-weight: 600;">${text}</span>`;
					},

				},
				{
					title: "Action Booking",
					type: "custom-html",
					key: "id",
					modifier: (value, rowData) => {

						var buttonAction = '';

						if(this.can('attend_booking')){
							const bookedDate = new Date(rowData.booked_date);
							const today = new Date();

							let  placement_status = (rowData.placement_status != '3' && rowData.placement_status != '2'  && rowData.placement_status != '4'  && rowData.placement_status != '5' && bookedDate.toDateString() <= today.toDateString()) ? false : true;

							if(rowData.no_class == 1){
								placement_status = true;
							}
							if(placement_status == false && rowData.placement_type.id !='3' ){
								buttonAction += `<button 
										class="btn btn-success" 
										data-toggle="tooltip" 
										title="Attended"
										style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
										onclick="window.handleAttend(${rowData.id})"
										${placement_status ? "disabled" : ""}
									>
										<i class="fa fa-check"></i>
									</button>`;
							}
						}

						if(this.can('reschedule_booking')){
							let  placement_status_reschedule = (rowData.placement_status != '3' && rowData.placement_status != '2'  && rowData.placement_status != '4' && rowData.placement_status != '5') ? false : true;
						
							if(rowData.no_class == 1){
								placement_status_reschedule = true;
							}
							if(rowData.placement_type.id !='3'  && placement_status_reschedule== false){
								buttonAction += `<button 
										class="btn btn-success" 
										data-toggle="tooltip" 
										title="Reschedule"
										style="border-radius: 50% !important; padding: 0.4rem 0.5rem;margin-left:2px;"
										onclick="window.handleReschedule(${rowData.id})"
										${placement_status_reschedule ? "disabled" : ""}
									>
										<i class="fa fa-edit"></i>
									</button>`;
							}
						}

						if(this.can('cancel_booking')){
							let  placement_status_cancel = (rowData.placement_status != '3' && rowData.placement_status != '2'   && rowData.placement_status != '4' && rowData.placement_status != '5') ? false : true;
								
							if(rowData.no_class == 1){
								placement_status_cancel = true;
							}
							if(placement_status_cancel == false && rowData.placement_type.id !='3'){
								buttonAction += `<button 
										class="btn btn-success" 
										data-toggle="tooltip" 
										title="Cancel"
										style="border-radius: 50% !important; padding: 0.4rem 0.5rem;margin-left:2px;"
										onclick="window.handleCancelBooking(${rowData.id})"
										${placement_status_cancel ? "disabled" : ""}
									>
										<i class="fa fa-times"></i> 
									</button>`;
							}
						}

						return buttonAction;
							


					}
				},
				{
					title: "Notes Booking",
					type: "text",
					key: "notes",
				},
				{
					title: "Results",
					type: "custom-html",
					key: "id",
					modifier: (value, rowData) => {
    					const recommendCount = rowData?.recomend_class?.length || 0;
						const status =
							typeof rowData.placement_status === "object" && rowData.placement_status !== null
								? rowData.placement_status.id
								: rowData.placement_status;

						// Default: semua tombol disabled
						let disableEdit = true;
						let disableDownload = true;
						let disableApprove = true;
						let disableCancel = true;

						// Kondisi berdasarkan status
						switch (status) {
							case 2:
							case 3:
								disableEdit = true;
								disableDownload = false;
								break;
							case 4:
								disableEdit = false;
								disableDownload = false;
								break;
							case 5:
								disableEdit = true;
								disableDownload = true;
								break;
							case 1:
								disableEdit = true;
								disableDownload = true;
								break;
							default:
								disableEdit = true;
								disableDownload = true;
								break;
						}
						var buttonAction = '';

						if(this.can('update_booking_results') && rowData.placement_type.id !='3'  && disableEdit == false){
							buttonAction += `
							<button 
								class="btn btn-success" 
								data-toggle="tooltip" 
    							title="Edit"
								style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
								onclick="window.handleResultClick(${rowData.id})"
								${disableEdit ? "disabled" : ""}
							>
								<i class="fa fa-edit"></i>
							</button>`;
						}
						if((rowData.result_header_placement_test && disableDownload == false) || rowData.placement_type.id =='3'){
							
							buttonAction+=`
								<button 
									class="btn btn-success"  
									data-toggle="tooltip" 
									title="View"
									style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
									onclick="window.handleViewClick(${rowData.id})"
									${disableDownload ? "disabled" : ""}
								>
									<i class="fa fa-eye"></i>
								</button>`;
								
							buttonAction += `
							<button 
								class="btn btn-success"  
								data-toggle="tooltip" 
    							title="Download PDF"
								style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
								onclick="window.handleDownloadPdfClick(${rowData.id})"
								${disableDownload ? "disabled" : ""}
							>
								<i class="fa fa-download"></i>
							</button>`;
						}
						return buttonAction;
					},
				},
				{
					title: "Confirm Parents",
					type: "custom-html",
					key: "id",
					modifier: (value, rowData) => {
    					const recommendCount = rowData?.recomend_class?.length || 0;
						const status =
							typeof rowData.placement_status === "object" && rowData.placement_status !== null
								? rowData.placement_status.id
								: rowData.placement_status;

						// Default: semua tombol disabled
						let disableApprove = true;
						let disableCancel = true;

						// Kondisi berdasarkan status
						switch (status) {
							case 2:
							case 3:
								disableApprove = true;
								disableCancel = true;
								break;
							case 4:
								disableApprove = false;
								disableCancel = false;
								break;
							case 5:
								disableApprove = true;
								disableCancel = true;
								break;
							case 1:
								disableApprove = false;
								disableCancel = false;
								break;
							default:
								disableApprove = true;
								disableCancel = true;
								break;
						}
						
						if(rowData.no_class == 1){
							disableApprove = true;
							disableCancel = true;
						}
						if(recommendCount == 0){
							disableApprove = true;
						}

						if(rowData.placement_type.id =='3' && rowData.placement_status !='3' && rowData.placement_status !='5'){
							disableApprove = false;
							disableCancel = false;
						}
						
						var buttonAction = '';
						if(this.can('approve_booking') && disableApprove == false){
							buttonAction += `
							
							<button 
								class="btn btn-success" 
								data-toggle="tooltip" 
    							title="Parent Confirm"
								style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
								onclick="window.handleApproveResult(${rowData.id})"
								${disableApprove ? "disabled" : ""}
							>
								<i class="fa fa-check"></i>
							</button>`;
						}
						if(this.can('declained_booking') && disableCancel == false){
							buttonAction += `
							<button 
								class="btn btn-danger" 
								data-toggle="tooltip" 
    							title="Parent Declained"
								style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
								onclick="window.handleCancelResult(${rowData.id})"
								${disableCancel ? "disabled" : ""}
							>
								<i class="fa fa-times"></i>
							</button>`;
						}


						return buttonAction;
					},
				},
				{
					title: "Notes Confirm Parents",
					type: "text",
					key: "notes_result",
				},
			],
			// actionObj: {
			// 	title: this.$t("action"),
			// 	type: "action",
			// },
			options: {
				name: "PlacementBookingTable",
				url: PLACEMENT + "?clc_id_number=" + this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		checkCallbackId(rowData) {
			if (rowData.placement_type.id === 1) {
				return "class-trial";
			} else if (rowData.placement_type.id === 2) {
				return "placement-test";
			} else if (rowData.placement_type.id === 3) {
				return "direct-placement";
			} else {
				return "placement-booking";
			}
		},
	},
};
